import type { Components } from '@mui/material/styles';

export default function MuiStepper(): Components['MuiStepper'] {
  return {};
}
